import Logger from '../lib/logger';
import event from '../lib/mixins/event';

class ThemeHeader {

	// Vars
	// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

	/**
	 * Class constructor
	 */
	constructor(dom) {

		this.NAME = 'ThemeHeader';

		this.dom = dom;

		this.activeClass = `theme-header--active`;

		this.hamburgerDom = this.dom.querySelector(`[data-theme-header-hamburger]`);
	}

	/**
	 * init - Initialize the form
	 */
	init() {
		Logger.info(`${this.NAME} > init`);

		this.hamburgerDom.addEventListener('click', this.toggle.bind(this));
	}

	/**
	 * toggle - Toggle the active class
	 */
	toggle() {
		Logger.info(`${this.NAME} > toggle`);

		this.dom.classList.toggle(this.activeClass);
	}

}

Object.assign(ThemeHeader.prototype, event);

export default ThemeHeader;
